import { Pipe, PipeTransform } from 'ng-metadata/core';

@Pipe({
  name: 'slugify',
})
export class SlugifyPipe implements PipeTransform {

  transform(input: string): string {
    if (typeof input !== 'string') {
      return input;
    }

    return input
      // Makes text lower case and trims
      .toLowerCase()

      // Replaces invalid chars with spaces
      .replace(/[^a-z0-9\s-]/g, ' ')

      // Remove whitespace from both sides
      .trim()

      // Replace multiple spaces or hyphens with a single hyphen
      .replace(/[\s-]+/g, '-')
    ;
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/pipes/slug.pipe.ts